import { lazy } from "react";
import { Navigate } from "react-router";

const ExperienceHome = lazy(() => import("../experience/components/ExperienceHome"));
const SurveyHistory = lazy(() => import("../experience/components/SurveyHistory/SurveyHistory"));
const Client = lazy(() => import("../experience/components/Client"));
const ProjectRedirect = lazy(() => import("../experience/components/Client/ProjectRedirect"));

const experienceRoutes = [
  { index: true, element: <ExperienceHome /> },
  { path: "history", element: <SurveyHistory /> },
  { path: "client", element: <Navigate replace to={`${process.env.PUBLIC_URL}/dashboard/experience`} /> },
  { path: "client/:contactId", element: <Client /> },
  { path: "client/project-redirect/:projectId", element: <ProjectRedirect /> },
];

export default experienceRoutes;
